import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { AdminService } from '@services/admin.service';
import { DialogService } from '@services/dialog.service';
import { DataStreamService } from '@services/data-stream.service';
import { TranslateService } from '@ngx-translate/core';
import { SupplierService } from '@services/supplier.service';
import { PartyService } from '@services/party.service';

import { Supplier } from '@models/supplier';
import { DataStream } from '@models/data-stream';

@Component({
  selector: 'app-supplier-detail',
  templateUrl: './supplier-detail.component.html',
  styleUrls: ['./supplier-detail.component.scss'],
  standalone: false
})
export class SupplierDetailComponent implements OnInit {

  public id!: string | null;
  public supplier!: Supplier | null;
  public dataStreams: DataStream[] | null = [];
  public loading: any = {
    'supplier': true,
    'dataUploadRel': false,
  };
  public defaultFormValues: any = {};

  constructor(
    private route: ActivatedRoute,
    private viewContainerRef: ViewContainerRef,
    private adminService: AdminService,
    private supplierService: SupplierService,
    private partyService: PartyService,
    private dialogService: DialogService,
    private translateService: TranslateService,
    private dataStreamService: DataStreamService,
  ) { }

  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get('id');
    this.reload();
  }

  public reload(): void {
    this.loading.supplier = true;

    this.supplierService.getSupplier(this.id).then((supplier: Supplier) => {
      this.supplier = supplier;
      this.defaultFormValues = supplier;

      console.log(supplier.relationships);

      return this.dataStreamService.getDataStreamsByParty(this.id || '');
    }).then((dataStreams: DataStream[] | null) => {
      this.dataStreams = dataStreams;

      this.loading.supplier = false;
    }).catch(() => {
      this.loading.supplier = false;
      this.dialogService.alert(null, this.translateService.instant("Dialog.SupplierDetailComponent.msg_supplierNotLoaded"), 'danger', 0, false);
    });
  }

  public async toggleSupplier(enable: boolean) {
    let title: string;
    let body: string;
    let messageSuccess: string;
    let messageFailure: string;
    if (enable) {
      title = this.translateService.instant("Dialog.SupplierDetailComponent.text_enableSupplier");
      body = this.translateService.instant("Dialog.SupplierDetailComponent.text_confirmEnableSupplier");
      messageSuccess = this.translateService.instant("Dialog.SupplierDetailComponent.msg_supplierEnabled");
      messageFailure = this.translateService.instant("Dialog.SupplierDetailComponent.msg_supplierNotEnabled");
    } else {
      title = this.translateService.instant("Dialog.SupplierDetailComponent.text_disableSupplier");
      body = this.translateService.instant("Dialog.SupplierDetailComponent.text_confirmDisableSupplier");
      messageSuccess = this.translateService.instant("Dialog.SupplierDetailComponent.msg_supplierDisabled");
      messageFailure = this.translateService.instant("Dialog.SupplierDetailComponent.msg_supplierNotEnabled");
    }

    if (! await this.dialogService.confirm(
      title,
      body,
      this.viewContainerRef
    )) {
      return;
    }

    this.dialogService.showLoader('supplier-detail.toggleSupplier');

    this.adminService.updatePartyEnabled(enable, this.supplier?.partyId).then(() => {
      this.dialogService.alert(null, messageSuccess, 'success');
      this.reload();

      this.dialogService.dismissLoader('supplier-detail.toggleSupplier');
    }).catch((error: string) => {
      this.dialogService.alert(null, error || messageFailure, 'danger');

      this.dialogService.dismissLoader('supplier-detail.toggleSupplier');
    });
  }

  public changeSupplierLogo() {
    this.dialogService.unimplementedWarning();
  }

  public toggleDataUploadRel() {
    this.loading.dataUploadRel = true;

    this.supplierService.toggleDataUploadRelationship(this.supplier?.partyId!).then(() => {
      this.loading.dataUploadRel = false;
      this.reload();
    }).catch(() => {
      this.loading.dataUploadRel = false;
      this.dialogService.alert(null, "Das hat leider nicht geklappt, bitte versuche es später erneut.", 'danger');
    });
  }

  public changeSupplierName() {
    this.dialogService.prompt(
      this.translateService.instant("Dialog.SupplierDetailComponent.text_changeNameTitle"),
      this.translateService.instant("Dialog.SupplierDetailComponent.text_changeNameBody"),
      'text',
      this.supplier?.attributes?.['NAME'] || '',
      this.viewContainerRef,
      this.translateService.instant("Dialog.SupplierDetailComponent.text_changeNameInput"),
    ).then((value: string | number | null) => {
      if (value) {
        this.dialogService.showLoader('supplier-detail.changeSupplierName');

        this.partyService.updatePartyName(value.toString(), this.supplier?.partyId).then(() => {
          this.dialogService.alert(null, this.translateService.instant("Dialog.SupplierDetailComponent.msg_supplierNameChanged"), 'success');
          this.reload();

          this.dialogService.dismissLoader('supplier-detail.changeSupplierName');
        }).catch((error: string) => {
          this.dialogService.alert(null, error || this.translateService.instant("Dialog.SupplierDetailComponent.msg_supplierNameNotChanged"), 'danger');

          this.dialogService.dismissLoader('supplier-detail.changeSupplierName');
        });
      }
    });
  }

  public changeSupplierGln() {
    console.log(this.supplier?.identifications);

    this.dialogService.prompt(
      this.translateService.instant("Dialog.SupplierDetailComponent.text_changeGlnTitle"),
      this.translateService.instant("Dialog.SupplierDetailComponent.text_changeGlnBody"),
      'text',
      this.supplier?.identifications?.find((id) => id.type == 'GLN')?.value || '',
      this.viewContainerRef,
      this.translateService.instant("Dialog.SupplierDetailComponent.text_changeGlnInput"),
    ).then((value: string | number | null) => {
      if (value) {
        this.dialogService.showLoader('supplier-detail.changeSupplierGln');

        this.supplierService.updateIdentification('GLN', value.toString(), this.supplier?.partyId!).then(() => {
          this.dialogService.alert(null, this.translateService.instant("Dialog.SupplierDetailComponent.msg_supplierGlnChanged"), 'success');
          this.reload();

          this.dialogService.dismissLoader('supplier-detail.changeSupplierGln');
        }).catch((error: string) => {
          this.dialogService.alert(null, error || this.translateService.instant("Dialog.SupplierDetailComponent.msg_supplierGlnNotChanged"), 'danger');

          this.dialogService.dismissLoader('supplier-detail.changeSupplierGln');
        });
      }
    });
  }
}